import rImg from "../../media/undraw_surveillance_k6wl.svg"
import useStore from "../../store/zustandstore";


function Reverification(){
    const setShowReVe = useStore((s)=>s.setShowReVe)

    const clsReVe =()=>{
        setShowReVe(false)
    }




    return(
       <div className="reveWrap">
  <div className="reveWrapCont">
    <img src={rImg} alt="Identity verification" />
    <span>Verify Your Identity</span>
    <p>
      We need you to complete a quick identity
      verification due to recent changes in your account activity.
    </p>
    <button onClick={() => clsReVe()}>Continue</button>
  </div>
</div>

    )
}

export default Reverification;